import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { sanitizeMailPrefix } from '@/utils/tools';
import OrganizationApi from '@/api/OrganizationApi';
import { useValidation } from '@orion.ui/orion';

type Props = SetupProps<typeof OrganizationReleaseNoteFormSetupService.props>

export default class OrganizationReleaseNoteFormSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({
		checking: false,
		checkingSuccess: false,
		errorMessage: undefined as Undef<string>,
		organization: {
			title: undefined as Undef<string>,
			mail: undefined as Undef<string>,
		},
	});

	validator = useValidation(this.state.organization, { title: 'required|length:3' });

	get organization () { return this.state.organization; }
	get errorMessage () { return this.state.errorMessage; }
	get checking () { return this.state.checking; }


	constructor (props?: Props) {
		super(props);
	}


	async generateAndVerifyMailAsync (payload: string) {
		if (!this.validator.validate()) return;
		this.generateMail(payload);
		await this.verifyTitleAsync();
	}

	async verifyTitleAsync () {
		try {
			this.state.checking = true;
			await OrganizationApi.checkOrganizationNameAndEmail({
				name: this.state.organization.title,
				email: this.state.organization.mail,
			});
			this.state.checkingSuccess = true;
			this.state.errorMessage = undefined;
		} catch (error: any) {
			this.state.checkingSuccess = false;
			this.state.errorMessage = error.response?.data;
		} finally {
			this.state.checking = false;
		}
	}

	generateMail (payload: string) {
		const mail = sanitizeMailPrefix(payload);
		this.state.organization.mail = `${mail}@myarmado.fr`;
	}

	async createOrganizationAsync () {
		try {
			this.state.checking = true;

			await OrganizationApi.add({
				name: this.state.organization.title,
				email: this.state.organization.mail,
			});

			// Une fois l'organisation créée, il faudrait refresh tout le site pour recharger les droits de l'utilisateur et afficher le menu complet
			// https://gitlab.armado.fr/armado/armado/-/issues/1458
			window.location.reload();
		} catch (error: any) {
			this.state.errorMessage = error?.response?.data;
		} finally {
			this.state.checking = false;
		}
	}
}
